
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/otwarte-osrodki-narciarskie",
      function () {
        return require("private-next-pages/[region]/otwarte-osrodki-narciarskie.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/otwarte-osrodki-narciarskie"])
      });
    }
  